import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ArztDatenResponseMitInputForm } from '../../api/client.service';
import { faSpinner } from '@fortawesome/pro-solid-svg-icons';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import {
  animate,
  state,
  style,
  transition,
  trigger,
} from '@angular/animations';

enum BED_UNCHECKED {
  bed1,
  bed2,
}

@Component({
  selector: 'san-zustimmung-digi-tne-zwei',
  templateUrl: './zustimmung-digi-tne-zwei.component.html',
  styleUrls: ['./zustimmung-digi-tne-zwei.component.scss'],
  standalone: false,
  animations: [
    trigger('submitError', [
      state(
        'base',
        style({
          boxShadow: '0 0 0 0 rgba(255, 0, 0, 0.7)',
        }),
      ),
      state(
        'pulsed',
        style({
          boxShadow: '0 0 5px 5px rgba(255, 0, 0, 0)',
        }),
      ),
      transition('base => pulsed', [animate('0.3s')]),
    ]),
  ],
})
export class ZustimmungDigiTneZweiComponent implements OnInit {
  @Input() state: ArztDatenResponseMitInputForm;
  @Input() sending = false;

  @Output() bestaetigenClicked = new EventEmitter<{
    zustimmungEvaluation: boolean;
  }>();
  @Output() zurueck = new EventEmitter();
  spinnerIcon = faSpinner;
  bed1 = new FormControl(false, [Validators.requiredTrue.bind(Validators)]);
  bed2 = new FormControl(false, [Validators.requiredTrue.bind(Validators)]);
  bedGroup = new FormGroup([this.bed1, this.bed2]);
  zustimmungEvaluation = false;
  submitChecking: BED_UNCHECKED[] = [];
  protected readonly BED_UNCHECKED = BED_UNCHECKED;

  constructor() {}

  ngOnInit(): void {}

  onBestaetigenClicked() {
    if (this.sending || !this.bedGroup.valid) {
      this.bed1.markAsTouched();
      this.bed2.markAsTouched();
      if (!this.bed1.valid) {
        this.submitChecking = [this.BED_UNCHECKED.bed1];
      }
      if (!this.bed2.valid) {
        this.submitChecking = [...this.submitChecking, this.BED_UNCHECKED.bed2];
      }
      setTimeout(() => (this.submitChecking = []), 500);
      return;
    }
    this.bestaetigenClicked.emit({
      zustimmungEvaluation: this.zustimmungEvaluation,
    });
  }
}
